export { userMockData } from './user-mock-data';
export { roleMockData } from './role-mock-data';
